import { RefreshIcon } from "@heroicons/react/outline";
import { observer } from "mobx-react-lite";

import { useBlock } from "./block-store";
import { useIsReadonly } from "./readonly-context";

import { BasicTooltip } from "@/components/ui/Tooltip";
import { Button } from "@/components/ui/button";

interface RetryButtonProps {
  onRetry?: () => void;
  isVisible?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  tooltipContent?: string;
}

const RetryButton = observer(
  ({
    onRetry,
    isVisible = true,
    isLoading = false,
    disabled = false,
    tooltipContent = "Retry this step",
  }: RetryButtonProps) => {
    const block = useBlock();
    const isReadonly = useIsReadonly();

    if (!isVisible || isReadonly || block.hasChanges) {
      return null;
    }

    if (!block.id || block.id.toString().startsWith("default_block_id_")) {
      return null;
    }

    const handleClick = () => {
      if (!disabled && !isLoading && onRetry) {
        onRetry();
      }
    };

    const isButtonDisabled = disabled || isLoading || !onRetry;

    const button = (
      <Button variant="ghost" size="tinyIcon" onClick={handleClick} disabled={isButtonDisabled}>
        <RefreshIcon className={`h-4 w-4 ${isLoading ? "animate-spin" : ""}`} />
      </Button>
    );

    return (
      <BasicTooltip content={tooltipContent}>
        <span className="inline-block">{button}</span>
      </BasicTooltip>
    );
  },
);

export default RetryButton;
